import React, { useEffect, useRef, useState } from 'react'
import {useNavigate, useParams } from 'react-router-dom';
import ToastService from '../../../Admin/services/ToastService';
import ClientService from '../../services/ClientService';
import { Toast } from 'primereact/toast';
import 'datatables.net';
import $ from 'jquery';
import { MdAddCircleOutline, MdMargin } from 'react-icons/md';
import RegisterUserService from '../../../Admin/services/RegisterUserService';
import AddFBIntegtarion from '../FBIntegration';
import AddSubscription from '../Subscription/AddSubscription';


function EditClient() {

  const toast = useRef(null);
  const { id } = useParams();  
  const navigate = useNavigate();
  //const toastService = new ToastService(toast); 
  const [toastService, setToastService] = useState(null);
  const [users, setUsers] = useState([]);

  const [form, setForm] = useState({
    agencyName: "",
    email: "",
    phoneNumber: "",
    streetAddress: "",  
    city: "",
    state: "",
    country:"",
    postalCode:"",
    gstNumber:"",
    agencyLogo:null,
    license:"",
    registrationNumber:"",
    id: id,
});

const [formError, setFormError] = useState({}); 
  const [activeTab, setActiveTab] = useState('edit');

  

  useEffect(() => {

    if (toast.current && !toastService) {
      setToastService(new ToastService(toast));
    }

    const fetchClients = async () => {
      try {
        const data = await ClientService.getClientById(id);
        setForm(data);
      } catch (error) {
        console.error('Error fetching Clients data:', error);
      } 
    };

    fetchClients();
  }, [id,toastService]);

  useEffect(() => {    
    const fetchUsers = async () => {
      try {
        const users = await RegisterUserService.getUsersByClientId(id);
        setUsers(users);
      } catch (error) {
        console.error('Error fetching Users: ', error);  
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch users data' });
      }
    };
    fetchUsers();
    setTimeout(() => {
      $('#tableData').DataTable();
    }, 1000);
  }, []);
  
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({ ...prevForm, [name]: value }));
  };
  

  const validateForm = () => {

    const errors = {};
    if (!form.agencyName.trim()) errors.agencyName = "Please enter the Client name.";
    setFormError(errors);

    if (Object.keys(errors).length > 0) {
      toastService.showWarning('Validation Error', 'Please fill out all required fields');
    }

    return Object.keys(errors).length === 0;
  };

  const onClientSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    updateClient();
  };

  
  const updateClient = async () => {
    const formDataToSend = new FormData();
    Object.keys(form).forEach(key => {
          formDataToSend.append(key, form[key]);
        }
      );
    try {
        debugger
      await ClientService.updateClient(id, formDataToSend); 
      toastService.showSuccess('Success', 'Client updated successfully');
      setTimeout(() => {
      navigate(-1);
      }, 1000); 
    } catch (error) {
      console.error("Error updating Client:", error);
      toastService.showError('Error', 'Failed to update Client');
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); 
      reader.onload = () => {
        const agencyLogo = reader.result.split(',')[1]; 
        setForm({ ...form, agencyLogo });
        setFormError((prevErrors) => ({ ...prevErrors, agencyLogo: '' })); 
      };
      reader.onerror = (error) => {
        console.error('Error reading file:', error);
      };
    }
  };

  function renderUsers() {
    return users.map((user) => {
      const roles = Roles.find((role) => role.id == user.roleId);
      const roleName = roles ? roles.name : "Unknown";
  
      return (
        <tr key={user.id}>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">
              {user.firstName} {user.lastName}
            </span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold"> {user.email}</span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">
              {user.contactNumber}
            </span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">
              {`${user.streetAddress}, ${user.city}, ${user.state}, ${user.country}, ${user.postalCode}`}
            </span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">{roleName}</span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">
              {user.isActive ? 'Active' : 'Inactive'}
            </span>
          </td>
          <td className="align-middle text-center">
            <span className="text-secondary text-xs font-weight-bold">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => navigate(`/editclientuser/${user.id}`)}
              >
                <i className="pi pi-pencil" style={{ fontSize: '1.5rem' }}></i>
              </button>
              <button
            className="btn btn-outline-light btn-sm"
            onClick={() => deleteUser(user.id)}
          >
            <i className="pi pi-trash" style={{ fontSize: '1.5rem', color: 'red' }}></i>
          </button>
            </span>
          </td>
        </tr>
      );
    });
  }
  
  const deleteUser = async (userId) => {
    try {
      await RegisterUserService.deleteUser(userId);
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'User deleted successfully', life: 3000 });
      setUsers(users.filter(user => user.id !== userId));
    } catch (e) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete user', life: 3000 });
      console.log(e);
    }
  };
  
  const Roles = [
    { id: 1, name: "SuperAdmin" },
    { id: 2, name: "Admin" },
    { id: 3, name: "Manager" },
    { id: 4, name: "Employee" }, 
  ];

  return (
    <div>
            <div className="row m-2 p-2">
            <div className="card text-center mx-auto">
            <div className="card-header bg-heading text-white">
                </div>
         <Toast ref={toast} />
         <ul className="nav nav-tabs">
        <li className="nav-item">
          <a className={`nav-link ${activeTab === 'edit' ? 'active' : ''}`} onClick={() => setActiveTab('edit')}>Details</a>
        </li>
        <li className="nav-item">
          <a className={`nav-link ${activeTab === 'integration' ? 'active' : ''}`} onClick={() => setActiveTab('integration')}>Integration</a>
        </li>
        <li className="nav-item">
          <a className={`nav-link ${activeTab === 'users' ? 'active' : ''}`} onClick={() => setActiveTab('users')}>Users</a>
        </li>
        <li className="nav-item">
          <a className={`nav-link ${activeTab === 'services' ? 'active' : ''}`} onClick={() => setActiveTab('services')}>Services</a>
        </li>
        <li className="nav-item">
          <a className={`nav-link ${activeTab === 'subscription' ? 'active' : ''}`} onClick={() => setActiveTab('subscription')}>Subscription</a>
        </li>
      </ul>
      {activeTab === 'edit' && ( 
        <form onSubmit={onClientSubmit} class="m-2 p-2">
          <div className="form-group row ">
            <label className="col-md-3 col-form-label" htmlFor="agencyName">
              Agency Name
            </label>
            <div className="col-md-3">
              <input
                type="text"
                name="agencyName"
                id="agencyName"
                className={`form-control ${formError.agencyName ? 'is-invalid' : ''}`}
                placeholder="Agency Name"
                onChange={changeHandler}
                value={form.agencyName}
              />
              {formError.agencyName && <div className="invalid-feedback">{formError.agencyName}</div>}
            </div>

            <label className="col-md-2 col-form-label" htmlFor="email">
              Email
            </label>
            <div className="col-md-3">
              <input
                type="email"
                name="email"
                id="email"
                className={`form-control ${formError.email ? 'is-invalid' : ''}`}
                placeholder="Email"
                onChange={changeHandler}
                value={form.email}
              />
              {formError.email && <div className="invalid-feedback">{formError.email}</div>}
            </div>
        </div>
        <div className="form-group row">
          <label className="col-md-3 col-form-label" htmlFor="phoneNumber">
            Phone Number
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="phoneNumber"
              id="phoneNumber"
              className={`form-control ${formError.phoneNumber ? 'is-invalid' : ''}`}
              placeholder="Phone Number"
              onChange={changeHandler}
              value={form.phoneNumber}
            />
            {formError.phoneNumber && <div className="invalid-feedback">{formError.phoneNumber}</div>}
          </div>

          <label className="col-md-2 col-form-label" htmlFor="streetAddress">
            Street Address
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="streetAddress"
              id="streetAddress"
              className={`form-control ${formError.streetAddress ? 'is-invalid' : ''}`}
              placeholder="Street Address"
              onChange={changeHandler}
              value={form.streetAddress}
              maxLength="100"
            />
            {formError.streetAddress && <div className="invalid-feedback">{formError.streetAddress}</div>}
          </div>


        </div>
        <div className="form-group row">
          <label className="col-md-3 col-form-label" htmlFor="city">
            City
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="city"
              id="city"
              className={`form-control ${formError.city ? 'is-invalid' : ''}`}
              placeholder="City"
              onChange={changeHandler}
              value={form.city}
            />
            {formError.city && <div className="invalid-feedback">{formError.city}</div>}
          </div>

          <label className="col-md-2 col-form-label" htmlFor="state">
            State
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="state"
              id="state"
              className={`form-control ${formError.state ? 'is-invalid' : ''}`}
              placeholder="State"
              onChange={changeHandler}
              value={form.state}
            />
            {formError.state && <div className="invalid-feedback">{formError.state}</div>}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-3 col-form-label" htmlFor="postalCode">
            Postal Code
          </label>
          <div className="col-md-3">
            <input
              type="number"
              name="postalCode"
              id="postalCode"
              className={`form-control ${formError.postalCode ? 'is-invalid' : ''}`}
              placeholder="Postal Code"
              onChange={changeHandler}
              value={form.postalCode}
            />
            {formError.postalCode && <div className="invalid-feedback">{formError.postalCode}</div>}
          </div>

          <label className="col-md-2 col-form-label" htmlFor="country">
            Country
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="country"
              id="country"
              className={`form-control ${formError.country ? 'is-invalid' : ''}`}
              placeholder="Country"
              onChange={changeHandler}
              value={form.country}
            />
            {formError.country && <div className="invalid-feedback">{formError.country}</div>}
          </div>

        </div>
    
         
    
        <div className="form-group row">
          <label className="col-md-3 col-form-label" htmlFor="gstNumber">
            GST Number
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="gstNumber"
              id="gstNumber"
              className={`form-control ${formError.gstNumber ? 'is-invalid' : ''}`}
              placeholder="GST Number"
              onChange={changeHandler}
              value={form.gstNumber}
            />
            {formError.gstNumber && <div className="invalid-feedback">{formError.gstNumber}</div>}
          </div>

          <label className="col-md-2 col-form-label" htmlFor="agencyLogo">
            Agency Logo
          </label>
          <div className="col-md-3">
            <input
              type="file"
              name="agencyLogo"
              id="agencyLogo"
              className={`form-control ${formError.agencyLogo ? 'is-invalid' : ''}`}
              onChange={onFileChange}
            />
            {formError.agencyLogo && <div className="invalid-feedback">{formError.agencyLogo}</div>}
          </div>

        </div>
    
        <div className="form-group row">
          <label className="col-md-3 col-form-label" htmlFor="license">
            License
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="license"
              id="license"
              className={`form-control ${formError.license ? 'is-invalid' : ''}`}
              placeholder="License"
              onChange={changeHandler}
              value={form.license}
            />
            {formError.license && <div className="invalid-feedback">{formError.license}</div>}
          </div>
          <label className="col-md-2 col-form-label" htmlFor="registrationNumber">
            Registration Number
          </label>
          <div className="col-md-3">
            <input
              type="text"
              name="registrationNumber"
              id="registrationNumber"
              className={`form-control ${formError.registrationNumber ? 'is-invalid' : ''}`}
              placeholder="Registration Number"
              onChange={changeHandler}
              value={form.registrationNumber}
            />
            {formError.registrationNumber && <div className="invalid-feedback">{formError.registrationNumber}</div>}
          </div>
        </div>
          
	  <div className="card-footer text-muted bg-light">
                    <button className="btn btn-save btn-dark text-white" type="submit">
                    <i className="fas fa-save"></i> Update
                    </button>
                </div>
      </form>
       )}
        {activeTab === 'integration' && (
          <div>
          <AddFBIntegtarion activeTab={activeTab}
           ClientId={id}
         />
   </div>
        )}

{activeTab === 'users' && (
  
  <div>
    <div className="form-group row">
      <div className="col-lg-12 float-end">
        <div className="col-lg-3 float-end">
          <a 
            className="btn bg-gradient-dark mb-0 float-end mt-3" 
            href="javascript:;"  
            onClick={() => { 
              navigate("/addclientuser", { state: { clientId: id } }); 
            }} 
          >
            <MdAddCircleOutline /> Add User
          </a>
        </div> 
      </div>  
    </div>
    {users.length === 0 ? (
      <p>No users found for this client.</p>
    ) : (
      <table className="table">
        <thead>
          <tr>
            <th className="text-center">Name</th>
            <th className="text-center">Email</th>
            <th className="text-center">Contact Number</th>
            <th className="text-center">Address</th>
            <th className="text-center">Role</th>
            <th className="text-center">Status</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
        {renderUsers()}
        </tbody>
      </table>
    )}
  </div>
)}

{activeTab === 'services' && (
  <div></div>
)}

{activeTab === 'subscription' && (
  <div>
    <AddSubscription activeTab={activeTab}
           ClientId={id}
         />
  </div>
)}

        </div></div></div>
  )
}

export default EditClient